module.exports = __webpack_public_path__ + "img/2x3_center.b94e9451.jpg";